module.exports = __webpack_public_path__ + "img/canopy--icon--gray.41a045b1.svg";